import { z } from 'zod';
import { EmailAlreadyTakenError } from 'libs/end-to-end/src/types/errors/email-already-taken-error';
import { OrganizationNotFoundError } from 'libs/end-to-end/src/types/errors/organization-not-found-error';
import { PasswordComplexityError } from 'libs/end-to-end/src/types/errors/password-complexity-error';
import { UnknownError } from 'libs/end-to-end/src/types/errors/unknown-error';
import { UserNotFoundError } from 'libs/end-to-end/src/types/errors/user-not-found-error';
import { UserUpdateNotAllowedError } from 'libs/end-to-end/src/types/errors/user-update-not-allowed-error';

export const UserUpdateError = z.union([
  UserNotFoundError,
  UserUpdateNotAllowedError,
  EmailAlreadyTakenError,
  PasswordComplexityError,
  OrganizationNotFoundError,
  UnknownError,
]);

export type UserUpdateError = z.infer<typeof UserUpdateError>;
